<p-menu
  [ngClass]="{'reduced': !isExpanded, 'expanded': isExpanded}"
  #menu     
  [model]="menuItems">
  <ng-template
    pTemplate="item"
    let-item>
    <a class="flex flex-col" [routerLink]="item.routerLink"
      [pTooltip]="!isExpanded ? (item?.label | translate) : null"
      [tooltipOptions]="tooltipOptions"
    routerLinkActive="p-menuitem-link-active"
    [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }">
      <div class="flex flex-row h-[20px]">
        <div><i class="relative top-[-6px] left-[-4px] text-[22px]" [ngClass]="item?.icon"></i></div>
        <div class="ml-2">{{item?.label | translate}}</div>
      </div>
    </a>
  </ng-template>
</p-menu>